import { Response, VesselsResponse } from "../../types";
import { buildResponse, callWorkflowGET } from "../generic";
import { VESSEL_ENDPOINTS } from "./endpoints";

export const getVessels = (
  setObject: (obj: Response<VesselsResponse[]>) => void,
  country_code?: string,
): void => {
  const response = callWorkflowGET<VesselsResponse[]>(VESSEL_ENDPOINTS.VESSEL, {
    params: { country_code },
  });
  buildResponse<VesselsResponse[]>(response, setObject);
};
